import React, { useContext, useEffect, useState } from "react";
import { Title } from "../../../../../../stories/Title/Title";
import Close from "../../../../../../images/Close.svg";
import RightArrow from "../../../../../../images/ArrowRight.svg";
import Signals from "../../../../../../images/ItemIcons/signals.svg";

import useUrlParams from "../../../../../../customHooks/useUrlParams";
import { payloadTypes } from "../../../../../../context/reducer";
import { AppContext } from "../../../../../../context/context";
import useLabels from "../../../../../../customHooks/useLabels";

import { useLazyQuery } from "@apollo/client";
import { DashboardVars, GetDashboardJunctionCountData } from "../types";
import { GetDashboardJunctionCount } from "../queries";

import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import { Button } from "../../../../../../stories/Button/Button";
import { CustomModal } from "../../../../../../utils/UtilFunctions";
import { AddModalStyles } from "../../../../../../styles/CustomModalStyles";
import CompleteSignalDetails, {
  JunctionPageType,
} from "./CompleteSignalDetails";
import Total from "../../../../../../images/dashboard/Total Count.svg";
import Working from "../../../../../../images/dashboard/Working.svg";
import NotWorking from "../../../../../../images/dashboard/Not Working.svg";
import VendorDetailsGraph from "./GraphWise/VendorDetailsGraph";
import TrafficSignalsChart from "./GraphWise/TrafficSignalsChart";
import { TicketStatus } from "../../../../../../utils/constants";
interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}
const TrafficSignalDetails = ({ setModalFlag }: Props) => {
  const { customer_id } = useUrlParams();
  const { state, dispatch } = useContext(AppContext);
  const [notWorkingJunction, setNotworkingJunctions] = useState(false);
  const { user_details } = useLoggedInUserDetails();
  const [junctionDetails, setJunctionDetals] = useState(false);
  const { junctionLabel } = useLabels();
  const [GetDashboardItems, { data }] = useLazyQuery<
    GetDashboardJunctionCountData,
    DashboardVars
  >(GetDashboardJunctionCount);
  useEffect(() => {
    if (customer_id || user_details.id) {
      GetDashboardItems({
        variables: {
          customerID: customer_id ? customer_id : 0,
          empID: user_details.id ? user_details.id : 0,
        },
      });
    }
  }, [customer_id, user_details.id, GetDashboardItems]);

  const CardsData = [
    {
      image: `${Total}`,
      label: "Total",
      total: data ? data.GetDashboardJunctionCount.totalCountData.total : 0,
      className: "d-signal-details__block--card",
    },
    {
      image: `${Working}`,
      label: "Working",
      total: data ? data.GetDashboardJunctionCount.totalCountData.working : 0,
      className: "d-signal-details__block--card",
    },
    {
      image: `${NotWorking}`,
      label: "Tickets Raised",
      total: data
        ? data.GetDashboardJunctionCount.ticketCountData.raisedTicket
        : 0,
      className: "d-signal-details__block--card--not-working",
    },
  ];

  return (
    <>
      <div className="d-signal-details">
        <div className="d-signal-details__title">
          <Title>{junctionLabel}</Title>
          <img src={Close} alt="" onClick={() => setModalFlag(false)} />
        </div>
        {/* <div className="d-signal-details__filters row g-0">
          {!company_id ? (
            <div className="col-2">
              <CompaniesAutocomplete
                onChange={(newValue) => {
                  if (newValue) {
                    dispatch({
                      type: payloadTypes.SET_COMPANY_ID,
                      payload: {
                        companyId: newValue.node.id,
                      },
                    });
                  } else {
                    dispatch({
                      type: payloadTypes.SET_COMPANY_ID,
                      payload: {
                        companyId: 0,
                      },
                    });
                  }
                }}
                onKeyDown={emptyFunc}
                label={companyLabel}
                value={state.companyId ? state.companyId : 0}
              />
            </div>
          ) : null}

          {!sub_id ? (
            <div className="col-2">
              <SubsidiarySelect
                onChange={(newValue) => {
                  if (newValue) {
                    dispatch({
                      type: payloadTypes.SET_SUB_ID,
                      payload: {
                        subsidiaryId: newValue.node.id,
                      },
                    });
                  } else {
                    dispatch({
                      type: payloadTypes.SET_SUB_ID,
                      payload: {
                        subsidiaryId: 0,
                      },
                    });
                    dispatch({
                      type: payloadTypes.SET_SUB_SITE_ID,
                      payload: {
                        subSiteId: 0,
                      },
                    });
                    dispatch({
                      type: payloadTypes.SET_JUNCTION_ID,
                      payload: {
                        junctionID: 0,
                      },
                    });
                  }
                }}
                label={subsidiaryLabel}
                companyID={
                  company_id
                    ? company_id
                    : state.companyId
                    ? state.companyId
                    : 0
                }
                onKeyDown={emptyFunc}
                value={state.subsidiaryId ? state.subsidiaryId : 0}
              />
            </div>
          ) : null}
          {!siteID ? (
            <div className="col-2">
              <SiteSelect
                onChange={(newValue) => {
                  if (newValue) {
                    dispatch({
                      type: payloadTypes.SET_SUB_SITE_ID,
                      payload: {
                        subSiteId: newValue.value,
                      },
                    });
                  } else {
                    dispatch({
                      type: payloadTypes.SET_SUB_SITE_ID,
                      payload: {
                        subSiteId: 0,
                      },
                    });
                    dispatch({
                      type: payloadTypes.SET_JUNCTION_ID,
                      payload: {
                        junctionID: 0,
                      },
                    });
                  }
                }}
                companyId={
                  company_id
                    ? company_id
                    : state.companyId
                    ? state.companyId
                    : 0
                }
                subsidiaryId={
                  sub_id ? sub_id : state.subsidiaryId ? state.subsidiaryId : 0
                }
                onKeyDown={emptyFunc}
                value={state.subSiteId ? state.subSiteId : 0}
                label={subsidiarySiteLabel}
              />
            </div>
          ) : null}
          {!junctionID ? (
            <div className="col-2">
              <JunctionsAutocomplete
                onChange={(newValue) => {
                  if (newValue) {
                    dispatch({
                      type: payloadTypes.SET_JUNCTION_ID,
                      payload: {
                        junctionID: newValue.node.id,
                      },
                    });
                  } else {
                    dispatch({
                      type: payloadTypes.SET_JUNCTION_ID,
                      payload: {
                        junctionID: 0,
                      },
                    });
                  }
                }}
                companyID={
                  company_id
                    ? company_id
                    : state.companyId
                    ? state.companyId
                    : 0
                }
                subsidiaryID={
                  sub_id ? sub_id : state.subsidiaryId ? state.subsidiaryId : 0
                }
                siteID={state.subSiteId ? state.subSiteId : 0}
                onKeyDown={emptyFunc}
                value={state.junctionID ? state.junctionID : 0}
                label={junctionLabel}
              />
            </div>
          ) : null}
        </div> */}
        {/* <div className="d-signal-details__total">
          <div>
            <b>Total</b>
            <span>{itemLabel}</span>
          </div>
          <div className="overall-total-count">
            <b>{data ? data.GetDashboardJunctionCount.length : 0}</b>
          </div>
        </div> */}

        {/* <Input id="data_search" placeholder="Search.." /> */}

        <div className="d-signal-details__block">
          <div className="d-signal-details__block--left">
            <div className="d-signal-details__block--cards">
              {CardsData.map((res) => {
                return (
                  <div
                    className={res.className}
                    onClick={() => {
                      if (res.label === "Tickets Raised") {
                        setNotworkingJunctions(!notWorkingJunction);
                      }
                    }}
                  >
                    <div className="d-signal-details__block--card--flex">
                      <img src={res.image} alt="" />
                      <span>{res.label}</span>
                    </div>

                    <b>{res.total}</b>
                    {res.label === "Tickets Raised" && (
                      <img src={RightArrow} alt="" />
                    )}
                  </div>
                );
              })}
            </div>

            <div className="d-signal-details__ul">
              <ul>
                {data ? (
                  data.GetDashboardJunctionCount.signalTypeData.map(
                    (signalData, signalIndex) => {
                      return (
                        <li
                          key={signalIndex}
                          onClick={() => {
                            dispatch({
                              type: payloadTypes.SET_JUNCTION_TYPE,
                              payload: {
                                junctionType: signalData.jType,
                              },
                            });
                            setJunctionDetals(!junctionDetails);
                          }}
                        >
                          <div className="d-signal-details--flex">
                            <span>{signalIndex + 1}</span>
                            <img src={Signals} alt="/" />
                            <label>{signalData.jType}</label>
                          </div>
                          <div className="d-signal-details--block">
                            <span>Total</span>
                            <b className="font-blue">{signalData.count}</b>
                          </div>
                          <div className="d-signal-details--block">
                            <span>Working</span>
                            <b className="font-green">{signalData.working}</b>
                          </div>
                          <div className="d-signal-details--block" id="bg">
                            <span>Tickets Raised</span>
                            <b className="font-red">{signalData.notWorking}</b>
                          </div>
                          <div className="d-signal-details--flex">
                            <img src={RightArrow} alt="" />
                          </div>
                        </li>
                      );
                    }
                  )
                ) : (
                  <b className="nodata">No data found</b>
                )}
              </ul>
            </div>
            <VendorDetailsGraph />
          </div>
          <div className="d-signal-details__block--left">
            <TrafficSignalsChart />
          </div>
        </div>

        <Button mode="cancel" onClick={() => setModalFlag(false)} />

        <CustomModal
          style={AddModalStyles}
          isOpen={junctionDetails}
          onRequestClose={() => setJunctionDetals(!junctionDetails)}
          contentComponent={
            <>
              <div className="d-asset-details__complete-details">
                <div className="d-asset-details__complete-details--title">
                  <Title>
                    {" "}
                    {state.itmDesc ? state.itmDesc : ""}{" "}
                    <b>({state.junctionType ? state.junctionType : null})</b>
                  </Title>
                  <img
                    src={Close}
                    alt=""
                    onClick={() => setJunctionDetals(!junctionDetails)}
                  />
                </div>

                <CompleteSignalDetails
                  setModalFlag={setJunctionDetals}
                  junctionPageType={JunctionPageType.TICKET_STATUS}
                />
              </div>
            </>
          }
        />

        <CustomModal
          style={AddModalStyles}
          isOpen={notWorkingJunction}
          onRequestClose={() => setNotworkingJunctions(!notWorkingJunction)}
          contentComponent={
            <>
              <div className="d-asset-details__complete-details">
                <div className="d-asset-details__complete-details--title">
                  <Title>
                    {" "}
                    {state.itmDesc ? state.itmDesc : ""}{" "}
                    {state.junctionType ? (
                      <b>({state.junctionType ? state.junctionType : null})</b>
                    ) : null}
                  </Title>
                  <img
                    src={Close}
                    alt=""
                    onClick={() => setNotworkingJunctions(!notWorkingJunction)}
                  />
                </div>

                <CompleteSignalDetails
                  setModalFlag={setNotworkingJunctions}
                  junctionPageType={JunctionPageType.NOT_WORKING_LIST}
                />
              </div>
            </>
          }
        />
      </div>
    </>
  );
};

export default TrafficSignalDetails;
